import * as Sentry from "@sentry/react";

const dsn = process.env.REACT_APP_SENTRY_DSN;

// Initialize Sentry only when a DSN is provided.
// In development (yarn start) we typically don't want to pollute production issues.
if (dsn) {
  Sentry.init({
    dsn,
    environment: process.env.NODE_ENV || "production",
    // Error monitoring only: no tracing, no replay, no profiling.
    integrations: [],
    // Strip large payloads we don't need.
    sendDefaultPii: false,
  });
}

export default Sentry;
